import { SET_SELECTED_MEMBERSHIP_COUPON, SET_PRESET_COUPON_CODE } from '@/store/mutationTypes'
import { membershipCoupon } from '@/api'
import { handleError } from '@/store/utils'

export default {
  actions: {

    checkMembershipCoupon({dispatch, commit, getters}, {code}) {
      return membershipCoupon.check({code, membershipTypeId: getters.selectedMembershipType.id})
        .then((response) => {
          let checkCouponCode = response.checkCouponCode;
          if (checkCouponCode && checkCouponCode.type == 'one_time') {
            console.warn("one_time coupons are not supported yet")
            //TODO: add support of one_time coupons
            handleError(commit, "This coupon type is not yet supported")
            checkCouponCode = null

          }
          dispatch('selectMembershipCoupon', checkCouponCode)
        })
    },

    removeMembershipCoupon({commit}) {
      commit(SET_SELECTED_MEMBERSHIP_COUPON, null)
    },

    selectMembershipCoupon({commit}, coupon) {
      commit(SET_SELECTED_MEMBERSHIP_COUPON, coupon)
    },

    setPresetMembershipCouponCode({commit}, couponCode) {
      commit(SET_PRESET_COUPON_CODE, couponCode)
    },

    removePresetMembershipCouponCode({commit}) {
      commit(SET_PRESET_COUPON_CODE, null)
    }
  }
}
